import{useState} from 'react';
import {toast} from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setProfileImg } from './redux/chatSlice';

function Upload ({closeModal}){
  const[postDialog,setPostDialog]=useState(true);
  const [file,setFile]=useState(null);
  const [preview,setPreview]=useState(null);
const dispatch= useDispatch();
   const handletouch=(e)=>{
    const selectedFile=e.target.files[0];
    if(!selectedFile) return;
    if(selectedFile.size > 2 * 1024*1024){
      alert('Image must be less than 2MB');
      return;
    }
   // if(!selectedFile) return;
    setFile(selectedFile);
    //comes out from input
       setPreview(URL.createObjectURL(selectedFile));
    };
const handleclick=async()=>{
if(!file) return;
   
     const imageUrl = URL.createObjectURL(file);
        dispatch(setProfileImg(imageUrl));
      toast.success(' Updated successfully')
 setPreview(null);
 closeModal();
};
/*try{
 const res=await axios.post('http://uploadImg',formData);
  toast.success(' posted successfully')
 setPreview(null);
    }catch(err){
      console.log('err');
       toast.error('Failed to post');
    };
   };*/
  return( 
    <>
    {postDialog && (
      <div className='overlay'>
      <div className='glass-pop' style={{width:'40%',padding:'15px'}}>
        <div className="header"style={{display:'flex',columnGap:'40px'}}>
     <h3 style={{whiteSpace:'nowrap'}}>Upload Profile Pic</h3>
     <h4 onClick={()=>setPostDialog(false)}>X</h4>
     </div>
     <hr></hr>
     <p style={{color:'#5959b1ff',backgroundColor:'#b8b8ecff',padding:'7px ',borderRadius:'5px',width:'62%',whiteSpace:'nowrap'}}>Note: The image should be square in shape</p>
      <input type='file'accept='image/*' style={{paddingLeft:'10'}} className='fileinput'onChange={handletouch}/>
      {preview &&(
   <img src={preview} alt='preview' className='image-preview' style={{maxWidth:'100%',maxHeight:'200px',objectFit:'cover'}}/>
)}
            <hr></hr>
    <div className='d-flex' style={{paddingLeft:'60%',margin:'20px',gap:'7px'}}>
   <button className='btn btn-primary'  onClick={handleclick}>Upload</button>
   <button className='btn btn-secondary' onClick={closeModal}>close</button>
   </div>
    </div> 
    </div>
    )};
    </>
  )
};
export default Upload;